
// This file is auto-generated on 'sanity dev'
// Modifications to this file is automatically discarded
import studioConfig from "../../sanity.config.ts"
import {renderStudio} from "sanity"

renderStudio(
  document.getElementById("sanity"),
  studioConfig,
  {reactStrictMode: false, basePath: "/"}
)
